// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__xGZ3t","log":"ModalInventoryLogs_log__GaUdu","date":"ModalInventoryLogs_date__3uzKu","userName":"ModalInventoryLogs_userName__2U212"};